import { api } from '../../client';

export interface JournalEntryLineDto {
  id: string;
  account: string;
  accountCode?: string;
  accountName?: string;
  description: string;
  debit: number;
  credit: number;
}

export interface JournalEntryDto {
  id: string;
  entryNumber: string;
  date: string;
  reference: string;
  description: string;
  status: string;
  lines: JournalEntryLineDto[];
}

export const accountingJournalsApi = {
  async list(
    search?: string
  ): Promise<{ data?: JournalEntryDto[]; message?: string; errors?: Record<string, string[]> }> {
    const q = search ? `?search=${encodeURIComponent(search)}` : '';
    return api.get(`/accounting/journals${q}`) as Promise<{ data: JournalEntryDto[] }>;
  },

  async get(id: string): Promise<{ data?: JournalEntryDto; message?: string }> {
    return api.get(`/accounting/journals/${id}`) as Promise<{ data: JournalEntryDto }>;
  },

  async create(data: {
    entry_number: string;
    date: string;
    reference: string;
    description: string;
    status: string;
    lines: Array<{ account_id: string; description: string; debit: number; credit: number }>;
  }): Promise<{ data?: JournalEntryDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/accounting/journals', data) as Promise<{
      data: JournalEntryDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    id: string,
    data: {
      entry_number?: string;
      date?: string;
      reference?: string;
      description?: string;
      status?: string;
      lines?: Array<{ account_id: string; description: string; debit: number; credit: number }>;
    }
  ): Promise<{ data?: JournalEntryDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/accounting/journals/${id}`, data) as Promise<{
      data: JournalEntryDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async delete(id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/accounting/journals/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },
};
